import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Paper, TableBody, TableCell, TableRow } from "@mui/material";
import styled from "@emotion/styled";

import { usePagination } from "Components/Common/BaseTable";
import Pagination from "Components/Common/BaseTable/Pagination";
import { convertCamelTextToCapitalizeText } from "utils/convertCamelTextToCapitalizeText";
import { StyledTable, StyledTableCell, StyledTableHead } from "./style";

const categoryKeys = ["firstHalf", "secondHalf", "annual"];

const generateCategoryData = (data, categoryKey) => {
  return data?.[0][categoryKey]?.reduce((acc, curr, i) => {
    return curr.consumerCategoryResponses?.map((item, j) => {
      // eslint-disable-next-line no-unused-vars
      const { count, ...rest } = item;
      return {
        ...rest,
        ...acc[j],
        [`count${i}`]: item.count,
      };
    });
  }, []);
};

const StyledTableContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "maxHeight",
})`
  max-height: ${({ maxHeight }) => maxHeight ?? "unset"};
  overflow-y: auto;
  .MuiPaper-root {
    overflow-x: scroll;
  }
`;

const GERCTable = ({ data, maxHeight, t }) => {
  const paginate = usePagination();
  const { page, setTotalPages } = paginate;

  const rowHeader = data?.[0]?.annual?.map((data) => data?.name);

  useEffect(() => {
    setTotalPages(Math.ceil(categoryKeys.length));
  }, [categoryKeys]);

  const categoryData = generateCategoryData(data, categoryKeys[page - 1]);

  return (
    <>
      <StyledTableContainer maxHeight={maxHeight}>
        <StyledTable>
          <StyledTableHead>
            <TableRow>
              <StyledTableCell>{t("GIFT CITY, Gandhinagar")}</StyledTableCell>
              <StyledTableCell>{t("Consumer Category")}</StyledTableCell>
              {rowHeader?.map((header, i) => (
                <StyledTableCell key={i}>{t(`${header}`)}</StyledTableCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {categoryData?.length ? (
              categoryData?.map(({ consumerCategory, ...rest }, j) => (
                <TableRow key={j}>
                  {j === 0 && (
                    <TableCell rowSpan={20}>
                      {convertCamelTextToCapitalizeText(categoryKeys[page - 1])}
                    </TableCell>
                  )}
                  <TableCell>{consumerCategory}</TableCell>
                  {Object.values(rest)?.map((count, k) => (
                    <TableCell key={k}>{count}</TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} className="text-center">
                  {t("No Data Available")}!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      {!!categoryData?.length && <Pagination paginate={paginate} />}
    </>
  );
};

GERCTable.propTypes = {
  data: PropTypes.array,
  maxHeight: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(GERCTable);
